import React from 'react'

import { ExampleWrapperSeamless } from '@/layout-components'

import FreeAccount from '@/housefolios-components/CreateAccount/FreeAccount'

import { Grid } from '@mui/material'

export default function ForgotPasswordPage() {
  return (
    <>
      <ExampleWrapperSeamless>
        <Grid
          container
          sx={{
            justifyContent: 'center',
          }}
        >
          <Grid size={12} sx={{ display: 'flex' }}>
            <FreeAccount />
          </Grid>
        </Grid>
      </ExampleWrapperSeamless>
    </>
  )
}
